<div
  class="h-full flex items-center justify-center flex-col gap-8 w-full bg-radial from-primary-400 to-primary-500 sm:from-transparent sm:to-transparent"
>
  <div
    class="flex flex-col sm:rounded-lg sm:shadow-[0_0_30px_rgba(0,0,0,0.2)] p-8 bg-white/90 sm:overlay-container w-full max-w-xl justify-center items-center h-full sm:h-auto min-h-[600px] gap-8"
  >
    <img
      src="logo_transparent_2_zeilig.webp"
      alt="Logo"
      class="w-2/3 sm:w-full sm:max-w-[320px] mb-2"
    />
    <div>
      <h1 class="text-2xl font-bold text-primary-500" i18n>Sign up</h1>
    </div>
    <form
      (ngSubmit)="onRegister()"
      [formGroup]="form"
      class="flex items-center justify-center flex-col gap-8 min-w-[300px]"
    >
      <div class="flex flex-col gap-3 w-full">
        <div class="flex flex-col gap-2">
          <label class="text-primary-500 text-center" i18n>Account Type</label>
          <p-selectButton
            [options]="accountTypeOptions()"
            [(ngModel)]="registrationType"
            [ngModelOptions]="{ standalone: true }"
            fluid
            class="mb-2"
          />
        </div>
        @if (registrationType() === "practice") {
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="far fa-building"></i>
            </p-inputgroup-addon>
            <input
              pInputText
              formControlName="practiceName"
              placeholder="Practice name"
              autocomplete="organization"
              i18n-placeholder
            />
          </p-inputgroup>
        }
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="far fa-user"></i>
          </p-inputgroup-addon>
          <input
            pInputText
            formControlName="firstName"
            placeholder="First name"
            autocomplete="given-name"
            i18n-placeholder
          />
        </p-inputgroup>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="far fa-id-card"></i>
          </p-inputgroup-addon>
          <input
            pInputText
            formControlName="lastName"
            placeholder="Last name"
            autocomplete="family-name"
            i18n-placeholder
          />
        </p-inputgroup>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="far fa-envelope"></i>
          </p-inputgroup-addon>
          <input
            pInputText
            formControlName="email"
            placeholder="Email"
            autocomplete="email"
            i18n-placeholder
          />
        </p-inputgroup>

        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="far fa-key"></i>
          </p-inputgroup-addon>
          <p-iconfield>
            <input
              [type]="passwordVisible() ? 'text' : 'password'"
              pInputText
              formControlName="password"
              placeholder="Password"
              autocomplete="new-password"
              i18n-placeholder
            />
            @if (passwordVisible()) {
              <p-inputicon
                class="far fa-eye-slash cursor-pointer"
                (click)="togglePassword()"
              />
            } @else {
              <p-inputicon
                class="far fa-eye cursor-pointer"
                (click)="togglePassword()"
              />
            }
          </p-iconfield>
        </p-inputgroup>
        @if (registrationType() === "patient") {
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="far fa-ticket"></i>
            </p-inputgroup-addon>
            <input
              pInputText
              formControlName="couponCode"
              placeholder="Coupon code (optional)"
              autocomplete="off"
              i18n-placeholder="@@complimentary.signupCouponOptional"
            />
          </p-inputgroup>
        }
        <div class="flex items-start gap-2 max-w-[400px]">
          <p-checkbox
            inputId="agbAccepted"
            formControlName="agbAccepted"
            [binary]="true"
            class="mt-0.5"
          />
          <label
            for="agbAccepted"
            class="text-sm text-neutral-700 cursor-pointer leading-snug"
          >
            <span i18n>I have read and accept the </span>
            <a
              routerLink="/agb"
              target="_blank"
              class="text-primary-600 hover:underline font-medium"
              i18n
              >Terms and Conditions (AGB)</a
            >
            <span i18n> and </span>
            <a
              routerLink="/privacy-policy"
              target="_blank"
              class="text-primary-600 hover:underline font-medium"
              i18n
              >Privacy Policy</a
            >.
          </label>
        </div>
        <div class="flex items-start gap-2 max-w-[400px]">
          <p-checkbox
            inputId="newsletterConsent"
            formControlName="newsletterConsent"
            [binary]="true"
            class="mt-0.5"
          />
          <label
            for="newsletterConsent"
            class="text-sm text-neutral-700 cursor-pointer leading-snug"
            i18n
          >
            I would like to receive the newsletter.
          </label>
        </div>
      </div>
      <div>
        <p-button label="Sign up" type="submit" i18n-label></p-button>
      </div>
    </form>
    <div class="flex flex-col gap-2 items-center justify-center">
      <div class="flex items-center gap-2">
        <p class="flex whitespace-nowrap gap-1 text-neutral-500 text-center">
          <span i18n>Already signed up? </span>
          <a
            routerLink="/signin"
            class="text-primary-500 underline underline-offset-1"
            i18n
          >
            Sign in
          </a>
        </p>
        <i class="far fa-arrow-right text-neutral-500"></i>
      </div>
      <small
        class="text-neutral-500 text-center flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-8 sm:mt-4"
      >
        <a
          routerLink="/agb"
          class="text-neutral-500 hover:text-primary-500 hover:underline underline-offset-2"
          i18n
        >
          Terms and Conditions
        </a>
        <span class="hidden sm:block"> | </span>
        <a
          routerLink="/privacy-policy"
          class="text-neutral-500 hover:text-primary-500 hover:underline underline-offset-2"
          i18n
        >
          Privacy Policy
        </a>
        <span class="hidden sm:block"> | </span>

        <a
          href="https://www.lalino.eu/?page_id=112"
          class="text-neutral-500 hover:text-primary-500 hover:underline underline-offset-2"
          i18n
        >
          Imprint
        </a>
        <button
          type="button"
          (click)="openWithdrawalDialog()"
          class="text-neutral-500 hover:text-primary-500 hover:underline underline-offset-2 bg-transparent border-0 p-0 cursor-pointer"
          i18n="@@withdrawal.open"
        >
          Cancel contract
        </button>
      </small>
    </div>
  </div>
</div>
